import { useQuery } from "@tanstack/react-query";
import { GetMeResponse } from "tng-address-collection-shared/types/portraitsApiTypes.ts";
import { useAuthentication } from "../../src/auth/useAuthentication.ts";
import { callPortraitApi } from "./portrait/portraitApi";

export const useGetMe = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: ["me"],
    queryFn: async ({ signal }) =>
      callPortraitApi("/api/me", GetMeResponse, {
        token: await getToken(),
        signal,
      }),
    enabled: isAuthenticated,
    staleTime: Infinity,
  });
};
